import { CollaboratorDetailTemplate } from "../../Templates/CollaboratorDetailTemplate";

export const CollaboratorDetail = () => {
  return <CollaboratorDetailTemplate />;
};
